import { ReactNode } from 'react';
import { useIsFetching } from '@tanstack/react-query';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Button from 'components/button/Button';
import { TRIGGERS_BASE_QUERY_KEY } from 'components/domain/automation/triggers/triggersQuery';
import { PageHeaderStyled } from 'pages/automations/common/Common.styles';

interface TriggersTabHeaderProps {
  children: ReactNode;
}

const TriggersTabHeader = ({ children }: TriggersTabHeaderProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const amountOfTriggersQueries = useIsFetching({
    queryKey: [TRIGGERS_BASE_QUERY_KEY],
  });
  const isFetchingTriggers = amountOfTriggersQueries > 0;

  return (
    <PageHeaderStyled
      buttons={
        <Button
          bsStyle="primary"
          data-testid="add-trigger-button"
          disabled={isFetchingTriggers}
          onClick={() => navigate('./add')}
        >
          {t('pageAutomations.triggers.addTrigger')}
        </Button>
      }
      noDivider
      subtitle={
        <Trans
          i18nKey="pageAutomations.triggers.subtitle"
          components={{
            link1: (
              <a
                aria-label="Hostfully documentation"
                href="https://help.hostfully.com/en/articles/1674808-create-custom-templates-and-triggers"
                target="_blank"
                rel="noreferrer"
              />
            ),
          }}
        />
      }
      title={t('pageAutomations.triggers.title')}
    >
      <div className="child-container">{children}</div>
    </PageHeaderStyled>
  );
};

export default TriggersTabHeader;
